import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CompanyMain from './pages/Company/CompanyMain';
import Contact from './pages/CsCenter/Contact';
import CsCenterMain from './pages/CsCenter/CsCenterMain';
import HostingMain from './pages/Hosting/HostingMain';
import CorocationMain from './pages/Corocation/CorocationMain';
import Main from './pages/Main/Main';
import CdnMain from './pages/Cdn/CdnMain';
import NHNCloudPage from './pages/CloudService/NHNCloudPage';
// import NAVERCloud from './pages/CloudService/NAVERCloud';
import AWSCloud from './pages/CloudService/AWSCloud';
import PrivacyPolicy from './pages/Policy/PrivacyPolicy';
import ServicePolicy from './pages/Policy/ServicePolicy';

const RoutePage = ({ mainFirstSectionRef }) => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Main firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/company"
        element={<CompanyMain firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/contact"
        element={<Contact firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/cs-center"
        element={<CsCenterMain firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/hosting"
        element={<HostingMain firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/corocation"
        element={<CorocationMain firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/cdn"
        element={<CdnMain firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/nhncloud"
        element={<NHNCloudPage firstSectionRef={mainFirstSectionRef} />}
      />
      {/* <Route
        path="/naverCloud"
        element={<NAVERCloud firstSectionRef={mainFirstSectionRef} />}
      /> */}
      <Route
        path="/awsCloud"
        element={<AWSCloud firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/privacy"
        element={<PrivacyPolicy firstSectionRef={mainFirstSectionRef} />}
      />
      <Route
        path="/servicepolicy"
        element={<ServicePolicy firstSectionRef={mainFirstSectionRef} />}
      />
    </Routes>
  );
};

export default RoutePage;
